import { Chip } from "@mui/material"
import type { FC } from "react"

import { SALES_ORDER_STATUS_TO_LABEL } from "../../constants"

import { SalesOrderStatus } from "@/graphql/codegen/graphql"

const SALES_ORDER_STATUS_TO_CLASS_NAME: Record<SalesOrderStatus, string> = {
  [SalesOrderStatus.Open]: "bg-primary-200",
  [SalesOrderStatus.Invoiced]: "bg-primary-200",
  [SalesOrderStatus.Confirmed]: "bg-tertiary-purple-300",
  [SalesOrderStatus.ReconfirmationNeeded]: "bg-tertiary-orange-300",
  [SalesOrderStatus.AwaitingPrepayment]: "bg-tertiary-yellow-300",
  [SalesOrderStatus.Canceled]: "bg-secondary-200",
  [SalesOrderStatus.Paid]: "bg-tertiary-green-100",
  [SalesOrderStatus.Completed]: "bg-tertiary-green-100",
} as const

interface SalesOrderStatusChipProps {
  status: SalesOrderStatus
}

export const SalesOrderStatusChip: FC<SalesOrderStatusChipProps> = ({ status }) => (
  <Chip
    size='small'
    variant='filled'
    label={SALES_ORDER_STATUS_TO_LABEL[status]}
    className={`rounded text-xs text-gray-900 ${SALES_ORDER_STATUS_TO_CLASS_NAME[status]}`}
  />
)
